// fr — checkin/quickCheck/stepTracker blocks translated.
export const fr = {
  "common": {
    "loading": "Chargement…",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "edit": "Modifier",
    "close": "Fermer",
    "confirm": "Confirmer",
    "back": "Retour",
    "next": "Suivant",
    "submit": "Envoyer",
    "search": "Rechercher",
    "select": "Sélectionner",
    "or": "Ou",
    "and": "et",
    "note": "Remarque",
    "viewAll": "Voir tout",
    "learnMore": "En savoir plus",
    "getStarted": "Commencer",
    "continue": "Continuer",
    "saving": "Enregistrement…"
  },
  "offline": {
    "banner": "Vous êtes hors ligne. Certaines fonctionnalités peuvent être limitées.",
    "savedLocally": "Enregistré hors ligne — synchronisation à la reconnexion",
    "syncing": "Synchronisation de vos mises à jour…",
    "backOnline": "Reconnecté — mises à jour synchronisées"
  },

  "nav": {
    "dashboard": "Tableau de bord",
    "nutrition": "Nutrition intelligente",
    "family": "Famille",
    "care": "Services",
    "careShort": "Services",
    "checkIn": "Bilan du jour",
    "insights": "Aperçus",
    "trends": "Tendances",
    "habits": "Habitudes",
    "medications": "Médicaments",
    "expertSupport": "Soutien expert",
    "profile": "Profil",
    "healthHub": "Centre santé",
    "support": "Aide & assistance",
    "wellness": "Bien-être",
    "education": "Éducation",
    "community": "Communauté",
    "preventiveHealth": "Santé préventive",
    "womensHealth": "Santé féminine",
    "reminders": "Rappels santé",
    "meals": "Repas",
    "orders": "Commandes",
    "subscription": "Abonnement",
    "logout": "Déconnexion"
  },

  "navShort": {
    "dashboard": "Accueil",
    "nutrition": "Nutrition",
    "family": "Famille",
    "care": "Services",
    "support": "Aide",
    "profile": "Profil",
    "stepTracker": "Podomètre"
  },
  "auth": {
    "sessionExpired": "Session expirée. Veuillez vous reconnecter.",
    "login": "Connexion",
    "register": "Créer un compte",
    "logout": "Se déconnecter",
    "email": "E-mail",
    "password": "Mot de passe",
    "name": "Nom complet",
    "forgotPassword": "Mot de passe oublié ?",
    "noAccount": "Pas encore de compte ?",
    "haveAccount": "Vous avez déjà un compte?",
    "signInHere": "Connectez-vous ici",
    "signUpHere": "Inscrivez-vous ici",
    "welcomeBack": "Bon retour !",
    "getStarted": "Commençons",
    "biometricLogin": "Se connecter avec la biométrie",
    "biometricHelper": "Utilisez votre empreinte digitale, Face ID ou Windows Hello",
    "vendorLogin": "Connexion Fournisseur",
    "createOne": "Créer un compte",
    "tagline": "Prenez soin de votre santé — un petit bilan chaque jour.",
    "takes30s": "Moins de 30 secondes",
    "emailPlaceholder": "vous@exemple.com",
    "passwordPlaceholder": "Votre mot de passe",
    "checking": "Vérification…",
    "continue": "Continuer",
    "secureMessage": "Sécurisé et privé — vos données sont protégées",
    "biometricSoon": "Connexion biométrique — Bientôt disponible",
    "showPassword": "Afficher le mot de passe",
    "hidePassword": "Masquer le mot de passe",
    "vendor": {
      "title": "Connexion Partenaire Fournisseur",
      "subtitle": "Accédez à votre tableau de bord fournisseur HealthLoop",
      "businessEmail": "E-mail professionnel",
      "emailPlaceholder": "fournisseur@entreprise.com",
      "passwordPlaceholder": "••••••••",
      "signingIn": "Connexion en cours...",
      "signIn": "Se connecter",
      "notVendorYet": "Pas encore partenaire fournisseur ?",
      "registerBusiness": "Inscrire votre entreprise",
      "areYouUser": "Êtes-vous un utilisateur ?",
      "userLogin": "Connexion Utilisateur",
      "welcomeBackToast": "Ravi de vous revoir !",
      "genericError": "Échec de la connexion. Veuillez réessayer."
    },
    "admin": {
      "backToUserLogin": "Connexion utilisateur",
      "title": "Connexion Admin",
      "restrictedBadge": "Accès restreint",
      "tagline": "Console opérateur HealthLoop — identifiants administrateur requis.",
      "emailLabel": "E-mail admin",
      "emailPlaceholder": "admin@votre-domaine.com",
      "passwordLabel": "Mot de passe",
      "passwordPlaceholder": "Entrez votre mot de passe admin",
      "signingIn": "Connexion en cours…",
      "submit": "Accéder à la console admin",
      "secureNote": "Connexion sécurisée · session cryptée",
      "restrictedTitle": "Cette zone est réservée aux administrateurs.",
      "restrictedBody": "Vous êtes connecté, mais votre compte n'a pas d'accès administrateur. Déconnectez-vous pour utiliser un autre compte ou retournez sur l'application principale.",
      "signOut": "Se déconnecter",
      "backToApp": "Retour à l'application"
    }
  },
  "quickCheck": {
    "header": {
      "title": "Comment vous sentez-vous aujourd'hui ?",
      "subtitle": "Bilan rapide — cela prend moins de 60 secondes"
    },
    "section1": {
      "title": "Que remarquez-vous aujourd'hui ?",
      "hint": "(Sélectionnez tout ce qui s'applique)"
    },
    "environment": {
      "title": "Votre environnement aujourd'hui",
      "hint": "Aidez-nous à comprendre ce qui vous entoure"
    },
    "basicChecks": {
      "title": "Vérifications rapides",
      "hint": "Optionnel mais utile"
    },
    "validation": {
      "pickOne": "Merci de répondre à au moins une question"
    },
    "submit": {
      "cta": "Obtenir mon conseil bien-être",
      "saving": "Enregistrement...",
      "analyzing": "Analyse de vos habitudes de santé...",
      "savedToast": "✅ Bilan enregistré ! Analyse de vos habitudes de santé..."
    }
  },
  "stepTracker": {
    "offline": {
      "title": "Mode hors ligne actif",
      "body": "Le suivi continue même hors ligne. Nous synchroniserons vos mises à jour lorsque vous serez reconnecté."
    },
    "permission": {
      "title": "Connectez pour un suivi automatique des pas",
      "body": "Autorisez HealthLoop à lire vos données {{platform}}. Vos données de bien-être restent sur votre appareil sauf si vous choisissez de les synchroniser.",
      "connect": "Connecter",
      "maybeLater": "Plus tard"
    },
    "sync": {
      "lastSynced": "Dernière sync {{time}}",
      "queued": "{{count}} mise à jour en attente de synchronisation.",
      "queuedPlural": "{{count}} mises à jour en attente de synchronisation.",
      "disconnect": "Déconnecter",
      "refreshAria": "Actualiser la synchronisation"
    },
    "progress": {
      "title": "Votre progression aujourd'hui",
      "stepsToday": "pas aujourd'hui",
      "goalLabel": "Objectif : {{goal}}",
      "stepsToGo": "{{remaining}} pas restants",
      "goalAchieved": "🎉 Objectif atteint",
      "goalAriaLabel": "Objectif atteint",
      "statGoal": "Objectif",
      "statProgress": "Progression",
      "statSource": "Source",
      "sourceDevice": "Appareil",
      "sourceManual": "Manuel"
    },
    "empty": {
      "waiting": "En attente des données d'activité",
      "startMoving": "Commencez à bouger pour démarrer le suivi",
      "shortWalkHint": "Faites une courte marche pour tester le suivi — ou enregistrez une entrée manuelle ci-dessous."
    },
    "manual": {
      "title": "Enregistrer les pas manuellement",
      "placeholder": "Entrez les pas",
      "submit": "Enregistrer",
      "footer": "Les entrées manuelles remplacent le décompte du jour. Elles se synchronisent automatiquement quand vous êtes en ligne."
    },
    "trust": {
      "title": "Privé par défaut",
      "itemData": "Vos données de bien-être restent sur votre appareil sauf si elles sont synchronisées à votre compte.",
      "itemOffline": "Le suivi continue même hors ligne — les mises à jour sont mises en file et synchronisées à la reconnexion.",
      "itemNoInvent": "Nous n'inventons jamais de pas. Seules les valeurs de votre appareil ou vos entrées manuelles sont stockées."
    },
    "howItWorks": {
      "title": "Comment ça marche",
      "itemConnect": "Connectez-vous à l'app santé de votre appareil pour un suivi mains libres.",
      "itemManual": "L'entrée manuelle reste toujours disponible comme solution de repli fiable.",
      "itemOfflineQueue": "Les mises à jour hors ligne sont mises en file localement et synchronisées dès le retour en ligne.",
      "itemDisconnect": "Déconnectez-vous à tout moment — votre historique enregistré reste sur cet appareil."
    },
    "header": {
      "title": "Suivi des pas",
      "subtitle": "Un suivi d'activité simple et honnête",
      "backToDashboard": "Retour au tableau de bord"
    },
    "today": {
      "title": "Pas du jour",
      "goalProgress": "{{current}} / {{goal}} pas",
      "goalReached": "Objectif atteint — beau travail !",
      "keepGoing": "Continuez comme ça — vous êtes sur la bonne voie."
    },
    "streak": {
      "label": "Série actuelle",
      "days": "{{count}} jour",
      "daysPlural": "{{count}} jours"
    },
    "badges": {
      "title": "Badges",
      "empty": "Vous gagnerez des badges en créant cette habitude."
    },
    "reminders": {
      "title": "Coups de pouce mouvement",
      "hint": "De légers rappels pour marcher un peu si vous restez assis longtemps.",
      "enabled": "Activé",
      "disabled": "Désactivé"
    },
    "insights": {
      "weeklyAverage": "Moyenne hebdomadaire",
      "weeklyGoal": "Objectif hebdomadaire"
    },
    "actions": {
      "connect": "Connecter une source de données",
      "manualLog": "Ajouter des pas manuellement",
      "changeGoal": "Modifier l'objectif quotidien"
    }
  },
  "checkin": {
    "header": {
      "title": "Bilan de santé quotidien",
      "subtitle": "Moins de 60 secondes",
      "restDayLink": "Je ne le sens pas aujourd'hui"
    },
    "snapshot": {
      "title": "Votre tableau de bord, actualisé",
      "healthScore": "Score de bien-être",
      "todayTasks": "Tâches du jour",
      "dayStreak": "jours consécutifs"
    },
    "resume": {
      "banner": "Reprenez là où vous vous étiez arrêté",
      "startFresh": "Recommencer",
      "dismiss": "Ignorer"
    },
    "progress": {
      "allSet": "Tout est prêt",
      "step": "Étape {{current}} sur {{total}}",
      "ariaLabel": "Progression du bilan quotidien : {{done}} sections sur {{total}} terminées"
    },
    "insights": {
      "title": "Vos perspectives de bien-être",
      "subtitle": "Personnalisées pour vous aujourd'hui",
      "insightForYou": "Conseil pour vous",
      "simpleActions": "Actions simples à entreprendre",
      "whenToSeekHelp": "Quand demander de l'aide",
      "nhsAdvice": "En cas d'inquiétude, contactez votre médecin traitant ou les services de santé",
      "backToDashboard": "Retour au tableau de bord",
      "newCheckIn": "Nouveau bilan",
      "disclaimer": "HealthLoop propose un accompagnement, pas un diagnostic médical."
    },
    "restDay": {
      "title": "Le repos fait partie du rythme.",
      "body": "Nous serons là demain, quand vous le sentirez.",
      "streakNote": "Votre série n'a pas bougé — elle se repose aussi.",
      "backToDashboard": "Retour au tableau de bord",
      "changedMind": "Finalement, j'aimerais faire mon bilan quand même."
    },
    "feelings": {
      "title": "Comment vous sentez-vous aujourd'hui ?",
      "hint": "Sélectionnez tout ce qui s'applique",
      "tired": "Fatigué(e)",
      "headache": "Mal de tête",
      "stressed": "Stressé(e) ou débordé(e)",
      "pain": "Courbatures ou douleurs",
      "okay": "Je me sens bien aujourd'hui"
    },
    "basics": {
      "title": "Vos essentiels",
      "sleepQ": "Avez-vous bien dormi la nuit dernière ?",
      "waterQ": "Avez-vous bu assez d'eau aujourd'hui ?",
      "foodQ": "Avez-vous mangé correctement aujourd'hui ?",
      "activityQ": "Quel a été votre niveau d'activité aujourd'hui ?",
      "yes": "Oui",
      "notReally": "Pas vraiment",
      "notYet": "Pas encore",
      "notActive": "Peu actif",
      "lightActivity": "Activité légère",
      "active": "Actif"
    },
    "mind": {
      "title": "Esprit et énergie",
      "stressQ": "Quel est votre niveau de stress aujourd'hui ?",
      "moodQ": "Comment est votre moral aujourd'hui ?",
      "energyQ": "Quel est votre niveau d'énergie aujourd'hui ?",
      "low": "Bas",
      "moderate": "Modéré",
      "high": "Élevé",
      "neutral": "Neutre",
      "good": "Bon",
      "okay": "Correct"
    },
    "day": {
      "title": "Votre journée",
      "routineQ": "Avez-vous suivi votre routine habituelle aujourd'hui ?",
      "yes": "Oui",
      "no": "Non"
    },
    "environment": {
      "title": "Votre environnement aujourd'hui",
      "describeQ": "Comment décririez-vous votre environnement ?",
      "comfortable": "😊 Confortable",
      "slightlyUncomfortable": "😐 Un peu inconfortable",
      "challenging": "😓 Difficile",
      "affectedQ": "Votre environnement a-t-il affecté votre ressenti ?",
      "yes": "Oui",
      "no": "Non",
      "exposureLabel": "Exposition (sélectionnez tout ce qui s'applique)",
      "heat": "🌡️ Chaleur",
      "cold": "❄️ Froid",
      "noise": "🔊 Bruit",
      "dustSmoke": "💨 Poussière ou fumée",
      "crowded": "👥 Lieu bondé",
      "none": "✅ Aucune"
    },
    "submit": {
      "analyzing": "Analyse de vos habitudes de santé...",
      "cta": "Voir mes perspectives de bien-être"
    },
    "toast": {
      "savedFull": "Bilan enregistré ! Votre tableau de bord est à jour.",
      "savedShort": "Bilan enregistré."
    }
  },
  "onboarding": {
    "welcome": "Bienvenue",
    "completeSetup": "Terminer la configuration",
    "stepProgress": "Étape {{step}} sur {{total}}",
    "percentComplete": "{{percent}}% terminé",
    "welcomeToast": "Bienvenue sur HealthLoop ! Votre profil est prêt.",
    "errorAgeRange": "Veuillez sélectionner votre tranche d’âge",
    "errorCountry": "Veuillez sélectionner votre pays",
    "errorGoal": "Veuillez sélectionner votre objectif santé principal",
    "errorCuisine": "Veuillez sélectionner au moins une cuisine préférée",
    "errorGeneric": "Échec de la configuration. Veuillez réessayer.",
    "step1Title": "Bienvenue sur HealthLoop ! 👋",
    "step1Subtitle": "Personnalisons votre parcours santé",
    "ageRangeLabel": "Quelle est votre tranche d’âge ?",
    "genderLabel": "Genre (facultatif)",
    "gender_male": "Homme",
    "gender_female": "Femme",
    "gender_non-binary": "Non-binaire",
    "gender_prefer_not_to_say": "Préfère ne pas dire",
    "step2Title": "Où vivez-vous ? 🌍",
    "step2Subtitle": "Cela nous aide à proposer des repas culturellement adaptés",
    "countryLabel": "Sélectionnez votre pays",
    "country_uk": "Royaume-Uni",
    "country_nigeria": "Nigéria",
    "country_ghana": "Ghana",
    "country_kenya": "Kenya",
    "country_south_africa": "Afrique du Sud",
    "country_usa": "États-Unis",
    "country_canada": "Canada",
    "country_india": "Inde",
    "country_jamaica": "Jamaïque",
    "country_other": "Autre",
    "step3Title": "Quel est votre objectif principal ? 🎯",
    "step3Subtitle": "Choisissez votre priorité santé",
    "additionalGoals": "D’autres objectifs ? (facultatif)",
    "goal_weight_loss": "Perte de poids",
    "goalDesc_weight_loss": "Perdre du poids sainement",
    "goal_weight_maintenance": "Maintenir le poids",
    "goalDesc_weight_maintenance": "Rester à votre poids actuel",
    "goal_muscle_gain": "Prise de muscle",
    "goalDesc_muscle_gain": "Gagner en force et en muscle",
    "goal_general_wellness": "Bien-être global",
    "goalDesc_general_wellness": "Amélioration générale de la santé",
    "goal_better_sleep": "Mieux dormir",
    "goalDesc_better_sleep": "Améliorer la qualité du sommeil",
    "goal_reduce_stress": "Réduire le stress",
    "goalDesc_reduce_stress": "Mieux gérer le stress",
    "goal_increase_energy": "Plus d’énergie",
    "goalDesc_increase_energy": "Se sentir plus énergique",
    "step4Title": "Préférences alimentaires 🍽️",
    "step4Subtitle": "Cuisines préférées et restrictions alimentaires",
    "cuisineLabel": "Cuisines préférées",
    "cuisineHint": "Sélectionnez-en au moins une (vous pouvez en choisir plusieurs)",
    "dietaryLabel": "Restrictions alimentaires (facultatif)",
    "diet_vegetarian": "Végétarien",
    "diet_vegan": "Végan",
    "diet_halal": "Halal",
    "diet_kosher": "Casher",
    "diet_gluten_free": "Sans gluten",
    "diet_dairy_free": "Sans lactose",
    "diet_pescatarian": "Pescetarien",
    "step5Title": "Conditions de santé 🏥",
    "step5Subtitle": "Facultatif — pour mieux personnaliser vos recommandations",
    "conditionsLabel": "Avez-vous l’une de ces conditions ?",
    "conditionsHint": "Ces informations sont privées et servent uniquement à personnaliser votre expérience",
    "condition_diabetes": "Diabète",
    "condition_hypertension": "Hypertension",
    "condition_heart_disease": "Maladie cardiaque",
    "condition_thyroid": "Problèmes thyroïdiens",
    "condition_celiac": "Maladie cœliaque",
    "condition_ibs": "Côlon irritable",
    "condition_none": "Aucune",
    "privacyTitle": "Vos données sont protégées",
    "privacyBody": "Vos informations personnelles sont chiffrées et stockées en toute sécurité. Nous utilisons ces données uniquement pour personnaliser votre expérience avec des recommandations alimentaires, des conseils santé et des notifications adaptés. Vos données ne seront jamais partagées avec des tiers sans votre consentement explicite.",
    "trackMedication": "Je souhaite suivre mes médicaments",
    "specialistInterest": "Les consultations avec un spécialiste m’intéressent",
    "welcomeTitle": "Bienvenue sur HealthLoop ! 👋",
    "welcomeSubtitle": "Personnalisons votre intelligence bien-être et prévention par IA en quelques étapes simples",
    "stepLabel": "Étape {{current}} sur {{total}}",
    "skipForNow": "Passer pour l'instant",
    "skipToast": "Vous pouvez terminer votre configuration à tout moment depuis votre profil",
    "back": "Retour",
    "next": "Suivant",
    "completing": "Finalisation...",
    "complete": "Terminer la configuration",
    "successToast": "Bienvenue sur HealthLoop ! Votre profil est désormais personnalisé 🎉",
    "failureToast": "Échec de la configuration",
    "validation": {
      "basicInfo": "Veuillez remplir toutes les informations de base",
      "pickGoal": "Veuillez sélectionner au moins un objectif de bien-être",
      "pickPrimary": "Veuillez sélectionner votre objectif principal",
      "pickRegion": "Veuillez sélectionner votre région culturelle pour des suggestions de repas adaptées",
      "pickFocus": "Veuillez sélectionner votre priorité bien-être"
    },
    "step1": {
      "title": "Votre Profil Bien-être",
      "description": "Aidez-nous à construire votre intelligence santé personnalisée",
      "age": "Âge *",
      "agePlaceholder": "ex: 30",
      "height": "Taille (cm) *",
      "heightPlaceholder": "ex: 170",
      "weight": "Poids (kg) *",
      "weightPlaceholder": "ex: 70"
    },
    "step2": {
      "title": "Vos Objectifs",
      "description": "Sélectionnez tout ce qui vous correspond, puis choisissez votre priorité",
      "primaryLabel": "Sélectionnez votre objectif principal *",
      "primaryBadge": "Principal"
    },
    "step3": {
      "title": "🌍 Culture et Préférences Culinaires",
      "description": "Aidez-nous à personnaliser vos recommandations de repas",
      "regionLabel": "Région Culturelle *",
      "regionHint": "Choisissez votre origine culturelle pour des idées de repas adaptées",
      "countryLabel": "Pays (Optionnel)",
      "countryPlaceholder": "ex: Sénégal, Côte d'Ivoire, Cameroun",
      "countryHint": "Pour des recommandations encore plus précises",
      "foodPrefLabel": "Diversité Alimentaire"
    },
    "step4": {
      "title": "Priorité Bien-être",
      "description": "Choisissez le domaine sur lequel vous souhaitez vous concentrer le plus"
    },
    "step5": {
      "title": "Vos Préférences",
      "description": "Personnalisez votre expérience HealthLoop",
      "trackMeds": "Suivi des Rappels",
      "trackMedsHint": "Activez le suivi et les rappels dans votre routine quotidienne",
      "specialist": "Intérêt pour l'accompagnement spécialisé",
      "specialistHint": "Accédez à des coachs bien-être, nutritionnistes et professionnels de l'équilibre mental",
      "confidentialTitle": "Soutien Confidentiel :",
      "confidentialBody": "Vos informations sont protégées et utilisées uniquement pour vous fournir des conseils de prévention personnalisés."
    },
    "step6": {
      "title": "Personnalisation des Repas",
      "description": "Aidez-nous à vous recommander des repas qui correspondent à vos goûts",
      "cuisinesLabel": "Cuisines Préférées (Optionnel)",
      "cuisinesHint": "Sélectionnez les cuisines que vous aimez le plus",
      "dietaryLabel": "Régimes Particuliers (Optionnel)",
      "dietaryHint": "Sélectionnez ce qui vous concerne",
      "allergiesLabel": "Allergies Communes (Optionnel)",
      "allergiesHint": "Sélectionnez vos allergies alimentaires",
      "personalisedTitle": "Repas Sur Mesure :",
      "personalisedBody": "Nous utiliserons ces préférences pour suggérer des repas adaptés à vos besoins. Vous pourrez les modifier plus tard dans les Réglages."
    },
    "healthGoals": {
      "better_sleep": "Mieux Dormir",
      "reduce_stress": "Moins de Stress",
      "increase_energy": "Plus d'Énergie",
      "weight_management": "Équilibre du Poids",
      "improve_fitness": "Meilleure Forme",
      "better_nutrition": "Manger Sain",
      "mental_wellness": "Équilibre Mental",
      "chronic_condition": "Gestion de l'Équilibre"
    },
    "wellnessFocus": {
      "mental_health": {
        "label": "Équilibre Mental",
        "description": "Focus sur l'humeur, le stress et le bien-être émotionnel"
      },
      "physical_fitness": {
        "label": "Forme Physique",
        "description": "Focus sur l'exercice, la force et l'activité"
      },
      "nutrition": {
        "label": "Nutrition",
        "description": "Focus sur l'alimentation et les repas sains"
      },
      "sleep": {
        "label": "Qualité du Sommeil",
        "description": "Focus sur le repos, les cycles de sommeil et la récupération"
      },
      "stress_management": {
        "label": "Gestion du Stress",
        "description": "Focus sur la relaxation et la détente"
      }
    },
    "culturalRegions": {
      "west_african": {
        "label": "Afrique de l'Ouest",
        "description": "Cuisine nigériane, ghanéenne, sénégalaise"
      },
      "east_african": {
        "label": "Afrique de l'Est",
        "description": "Cuisine kényane, éthiopienne, tanzanienne"
      },
      "north_african": {
        "label": "Afrique du Nord",
        "description": "Cuisine marocaine, égyptienne"
      },
      "southern_african": {
        "label": "Afrique Australe",
        "description": "Cuisine sud-africaine"
      },
      "caribbean": {
        "label": "Caraïbes",
        "description": "Cuisine jamaïcaine, trinidadienne, barbadienne"
      },
      "middle_eastern": {
        "label": "Moyen-Orient",
        "description": "Cuisine libanaise, palestinienne, syrienne"
      },
      "south_asian": {
        "label": "Asie du Sud",
        "description": "Cuisine indienne, pakistanaise, bangladaise"
      },
      "east_asian": {
        "label": "Asie de l'Est",
        "description": "Cuisine chinoise, japonaise, coréenne"
      },
      "southeast_asian": {
        "label": "Asie du Sud-Est",
        "description": "Cuisine thaïlandaise, vietnamienne, indonésienne"
      },
      "western": {
        "label": "Occidentale",
        "description": "Cuisine américaine, européenne"
      },
      "latin_american": {
        "label": "Amérique Latine",
        "description": "Cuisine mexicaine, brésilienne, argentine"
      },
      "mediterranean": {
        "label": "Méditerranéenne",
        "description": "Cuisine grecque, italienne, espagnole"
      }
    },
    "foodPreferences": {
      "traditional": {
        "label": "Traditionnel",
        "description": "Principalement des plats de votre culture"
      },
      "mixed": {
        "label": "Mixte",
        "description": "Équilibre entre cuisine locale et internationale"
      },
      "international": {
        "label": "International",
        "description": "Cuisines du monde variées"
      }
    },
    "cuisines": {
      "west_african": "Afrique de l'Ouest",
      "caribbean": "Caraïbes",
      "mediterranean": "Méditerranéenne",
      "asian": "Asiatique",
      "western": "Occidentale",
      "indian": "Indienne",
      "middle_eastern": "Moyen-Orient",
      "general": "Toutes les cuisines"
    },
    "dietary": {
      "vegetarian": "Végétarien",
      "vegan": "Végétalien",
      "pescatarian": "Pescétarien",
      "gluten_free": "Sans Gluten",
      "dairy_free": "Sans Lactose",
      "low_carb": "Faible en Glucides"
    },
    "allergies": {
      "nuts": "Fruits à coque",
      "shellfish": "Crustacés",
      "dairy": "Produits laitiers",
      "eggs": "Œufs",
      "soy": "Soja",
      "gluten": "Gluten"
    },
    "cuisine_nigerian": "Nigériane",
    "cuisine_ghanaian": "Ghanéenne",
    "cuisine_senegalese": "Sénégalaise",
    "cuisine_kenyan": "Kényane",
    "cuisine_ethiopian": "Éthiopienne",
    "cuisine_moroccan": "Marocaine",
    "cuisine_south_african": "Sud-africaine",
    "cuisine_jamaican": "Jamaïcaine",
    "cuisine_trinidadian": "Trinidadienne",
    "cuisine_lebanese": "Libanaise",
    "cuisine_turkish": "Turque",
    "cuisine_greek": "Grecque",
    "cuisine_italian": "Italienne",
    "cuisine_french": "Française",
    "cuisine_british": "Britannique",
    "cuisine_indian_south": "Indienne du Sud",
    "cuisine_indian_north": "Indienne du Nord",
    "cuisine_pakistani": "Pakistanaise",
    "cuisine_japanese": "Japonaise",
    "cuisine_chinese": "Chinoise",
    "cuisine_korean": "Coréenne",
    "cuisine_vietnamese": "Vietnamienne",
    "cuisine_thai": "Thaïlandaise",
    "cuisine_filipino": "Philippine",
    "cuisine_american": "Américaine",
    "cuisine_mexican": "Mexicaine",
    "cuisine_brazilian": "Brésilienne",
    "cuisine_peruvian": "Péruvienne"
  },
  "dashboard": {
    "welcome": "Heureux de vous revoir",
    "greeting": "Bonjour",
    "goodMorning": "Bonjour",
    "goodAfternoon": "Bon après-midi",
    "goodEvening": "Bonsoir",
    "tagline": "De petits pas sains créent un changement durable",
    "microcopy": "Votre parcours bien-être compte.",
    "welcomeSubtitleMorning1": "Un début de journée tout en calme.",
    "welcomeSubtitleMorning2": "Heureux que vous passiez ce matin.",
    "welcomeSubtitleMorning3": "Les petits moments comptent.",
    "welcomeSubtitleAfternoon1": "Que votre journée se déroule sereinement.",
    "welcomeSubtitleAfternoon2": "Bon retour sur HealthLoop.",
    "welcomeSubtitleAfternoon3": "Respirez — tout va bien.",
    "welcomeSubtitleEvening1": "Soirée tranquille avec vous.",
    "welcomeSubtitleEvening2": "Une douce clôture de journée.",
    "welcomeSubtitleEvening3": "Bon retour ce soir.",
    "title": "Votre plateforme de santé préventive",
    "subtitle": "Suivez, apprenez et agissez avant que les problèmes ne s’aggravent",
    "summary": "Votre synthèse santé",
    "summaryDesc": "Aperçus en temps réel sur la prévention, l'éducation, l'engagement et le bien-être",
    "comprehensiveSupport": "Support complet en prévention, éducation, engagement et bien-être",
    "todayCheckIn": "Bilan du jour",
    "quickActions": "Actions rapides",
    "healthOverview": "Vue d’ensemble santé",
    "recentActivity": "Activité récente",
    "viewAll": "Voir tout",
    "preventiveHealth": "Santé préventive",
    "preventiveHealthDesc": "Suivi quotidien, surveillance du bien-être et alertes préventives",
    "education": "Éducation",
    "educationDesc": "Aperçus basés sur des preuves, articles de santé et conseils d'experts",
    "engagement": "Engagement",
    "engagementDesc": "Défis communautaires, suivi des habitudes et soutien social",
    "wellness": "Bien-être",
    "wellnessDesc": "Nutrition intelligente, équilibre de vie et bien-être holistique",
    "todaysInsight": "Aperçu du jour",
    "wellnessScore": "Score bien-être",
    "healthStreak": "Série santé",
    "days": "jours",
    "logHealth": "Noter ma santé",
    "getEducated": "Apprendre",
    "communityChallenge": "Défi Communautaire",
    "checkWellness": "Vérifier le bien-être",
    "verified": "Vérifié",
    "joinCommunity": "Rejoindre la communauté",
    "personalizedPlan": "Plan personnalisé",
    "score": "Score",
    "checkIns": "bilans",
    "habits": "habitudes",
    "preventive": "Préventif",
    "healthMetrics": "Indicateurs santé",
    "trackMetrics": "Suivre les Métriques",
    "startTracking": "Commencer le suivi",
    "logMetrics": "Enregistrer les Métriques",
    "dailyInsight": "Aperçu Quotidien",
    "learnAbout": "Apprenez sur la santé préventive aujourd'hui",
    "articlesAvailable": "articles disponibles",
    "browseArticles": "Parcourir les Articles",
    "currentStreak": "Série Actuelle",
    "keepGoing": "Continuez!",
    "startStreak": "Commencez votre série",
    "checkIn": "Bilan",
    "nutritionPlan": "Plan de Nutrition",
    "mealsPlanned": "repas planifiés",
    "viewPlan": "Voir le Plan",
    "planYourWeek": "Planifiez votre semaine",
    "moodStress": "Humeur & stress",
    "howFeeling": "Comment vous sentez-vous ?",
    "logWellness": "Noter le bien-être",
    "medications": "Médicaments",
    "noMeds": "Aucun médicament suivi",
    "addMedications": "Ajouter des médicaments",
    "daysTracked": "Jours Suivis",
    "noHabits": "Aucune habitude encore",
    "startTrackingHabits": "Commencer à suivre les habitudes",
    "insights": "Aperçus",
    "noInsights": "Aucun aperçu encore",
    "completeFirstPlan": "Complétez votre premier plan",
    "noCheckIns": "Aucun enregistrement encore",
    "startFirstCheckIn": "Faites votre premier enregistrement"
  },
  "support": {
    "title": "Assistance",
    "subtitle": "Trouvez des réponses, contactez-nous ou signalez un problème",
    "backToSettings": "Retour aux paramètres",
    "privacyBanner": "Les demandes d’assistance sont traitées en toute confidentialité. Vos informations de santé restent privées.",
    "section1": "Section 1",
    "section2": "Section 2",
    "section3": "Section 3",
    "section4": "Section 4",
    "navHelpCenter": "Centre d’aide",
    "navContact": "Nous contacter",
    "navHealth": "Services santé",
    "navTechnical": "Support technique",
    "helpCenterTitle": "Centre d’aide",
    "helpCenterSubtitle": "Cherchez les questions courantes et trouvez des réponses rapides.",
    "contactTitle": "Nous contacter",
    "contactSubtitle": "Choisissez votre canal préféré pour joindre l’équipe.",
    "healthServicesTitle": "Services santé",
    "healthServicesSubtitle": "Accédez au suivi des médicaments et aux experts cliniques.",
    "technicalTitle": "Support technique",
    "technicalSubtitle": "Signalez un bug ou un problème, le contexte technique est capturé automatiquement.",
    "searchPlaceholder": "Cherchez les questions courantes…",
    "liveChat": "Chat en direct",
    "emailUs": "Envoyer un e-mail",
    "callBack": "Schedule a callback",
    "sendMessage": "Envoyer un message",
    "medicationTracking": "Medication tracking",
    "specialistAccess": "Specialist access",
    "videoConsultation": "Video consultation",
    "reportBug": "Report a bug",
    "yourName": "Votre nom",
    "yourEmail": "Votre e-mail",
    "subject": "Sujet",
    "message": "Message",
    "phone": "Phone",
    "description": "Description",
    "submit": "Envoyer",
    "successTitle": "Message envoyé",
    "successDescription": "Nous vous répondrons sous 24–48 heures.",
    "healthDisclaimer": "For medical emergencies, contact local emergency services. HealthLoop is not a substitute for professional medical care."
  },
  "nutrition": {
    "smartNutrition": "Nutrition intelligente",
    "basedOnGoal": "Selon votre objectif :",
    "personalizedData": "Personnalisé en fonction de vos données de santé récentes",
    "evidenceBased": "Nutrition basée sur des preuves dans le cadre de votre plan de santé préventive",
    "todaysMealSuggestions": "Suggestions de repas du jour",
    "customize": "Personnaliser",
    "breakfast": "Petit-déjeuner",
    "lunch": "Déjeuner",
    "dinner": "Dîner",
    "loadingBreakfast": "Chargement du petit-déjeuner...",
    "loadingLunch": "Chargement du déjeuner...",
    "loadingDinner": "Chargement du dîner...",
    "cal": "cal",
    "protein": "protéine",
    "swapMeal": "Remplacer le plat",
    "healthyOptionsNearYou": "Options saines près de chez vous",
    "enableLocation": "Activer la localisation",
    "view": "Voir",
    "discoverOptions": "Découvrez des restaurants sains, des épiceries et des fournisseurs de repas près de chez vous",
    "cuisinesSelected": "cuisines sélectionnées",
    "cuisineSelected": "cuisine sélectionnée",
    "dietaryPrefs": "préférences alimentaires",
    "dietaryPref": "préférence alimentaire",
    "customizeMeals": "Personnaliser les repas",
    "subtitleAdaptive": "Plan de repas culturellement adapté à vos objectifs santé",
    "hideFavorites": "Masquer les favoris",
    "viewFavorites": "Voir les favoris",
    "customizeMealsLegacy": "Customize meals to match your cultural preferences and dietary needs",
    "viewFullPlan": "Voir le plan complet",
    "exploreRecipes": "Découvrir des recettes"
  },
  "location": {
    "permissionTitle": "Trouvez des options saines près de chez vous",
    "permissionDesc": "Utilisé pour recommander des restaurants, des épiceries et des fournisseurs de repas alignés sur vos objectifs de santé.",
    "howToEnable": "Comment activer:",
    "step1": "Cliquez sur l'icône de cadenas 🔒 dans la barre d'adresse",
    "step2": "Trouvez les permissions de \"Localisation\"",
    "step3": "Changez en \"Autoriser\"",
    "step4": "Actualisez cette page",
    "refreshPage": "Actualiser la Page",
    "allowLocation": "Autoriser la Localisation",
    "notNow": "Pas maintenant",
    "denied": "L'accès à la localisation a été bloqué. Pour voir les options saines à proximité, vous devrez activer les permissions de localisation.",
    "unavailable": "Les informations de localisation ne sont actuellement pas disponibles. Veuillez vérifier les paramètres de votre appareil.",
    "error": "Impossible d'accéder à votre localisation. Veuillez réessayer ou vérifier les paramètres du navigateur.",
    "unsupported": "Votre navigateur ne prend pas en charge les services de localisation. Essayez d'utiliser un navigateur moderne comme Chrome, Firefox ou Safari.",
    "accessRequired": "Accès à la Localisation Requis"
  },
  "womensHealth": {
    "title": "Santé des Femmes",
    "description": "Suivez votre cycle, enregistrez les symptômes et obtenez des conseils de bien-être personnalisés en fonction de la phase de votre cycle",
    "cycleTracking": "Suivi du Cycle",
    "symptomLogging": "Enregistrement des Symptômes",
    "phaseInsights": "Aperçus de Phase",
    "logPeriod": "Enregistrer les Règles",
    "logSymptoms": "Enregistrer les Symptômes",
    "insights": "Aperçus",
    "tips": "Conseils de Santé",
    "overview": "Aperçu",
    "history": "Historique",
    "startTracking": "Commencez à Suivre Votre Cycle"
  },
  "profile": {
    "title": "Profil",
    "personalInfo": "Informations personnelles",
    "healthProfile": "Profil santé",
    "preferences": "Préférences",
    "language": "Langue",
    "selectLanguage": "Choisir la langue",
    "notifications": "Notifications",
    "privacy": "Confidentialité",
    "security": "Sécurité",
    "quickAccess": "Accès rapide",
    "editProfile": "Modifier le profil",
    "viewStats": "Voir mes statistiques",
    "backToDashboard": "Retour au tableau de bord",
    "womensHealthTitle": "Santé féminine",
    "womensHealthDesc": "Cycle tracking, symptoms & wellness tips",
    "healthRemindersTitle": "Rappels santé",
    "healthRemindersDesc": "Manage your notifications",
    "manageRemindersDesc": "Manage your reminder preferences and notifications",
    "healthPatternAlerts": "Your Health Pattern Alerts",
    "supportHelp": "Aide & assistance",
    "supportHelpDesc": "Get assistance, report issues, or browse FAQs",
    "admin": "Admin",
    "adminDesc": "View usage metrics and user behavior insights",
    "giveFeedback": "Donner un avis",
    "giveFeedbackDesc": "Share your experience with HealthLoop",
    "reportProblem": "Signaler un problème",
    "reportProblemDesc": "Help us fix bugs and improve the app",
    "manageHealthInfo": "Manage your preventive health information for personalized insights",
    "basicInformation": "Informations de base",
    "fullName": "Nom complet",
    "email": "E-mail",
    "dateOfBirth": "Date de naissance",
    "gender": "Genre",
    "height": "Taille (cm)",
    "weight": "Poids (kg)",
    "medicalConditions": "Medical Conditions",
    "allergies": "Allergies",
    "personalHealth": "Personal Health",
    "addCondition": "Add a medical condition",
    "addAllergy": "Add an allergy",
    "saveChanges": "Save Changes",
    "saving": "Saving...",
    "privacyMessage": "Your health data is protected with confidential care standards"
  },
  "settings": {
    "title": "Paramètres",
    "general": "Général",
    "account": "Compte",
    "appearance": "Apparence",
    "languageSettings": "Paramètres de Langue",
    "changeLanguage": "Changer de Langue",
    "languageNote": "L'interface se met à jour dès que vous sélectionnez une nouvelle langue. Les langues africaines et les nouvelles langues ajoutées sont marquées comme « Starter » — traduites automatiquement pour élargir l'accès, en attente d'une révision par des locuteurs natifs.",
    "languageUpdated": "Langue mise à jour avec succès",
    "starterBadge": "Starter",
    "starterBadgeTooltip": "Traduction automatique — révision par un locuteur natif en cours.",
    "regions": {
      "global": "Monde",
      "european": "Langues européennes",
      "middleEastern": "Langues du Moyen-Orient",
      "asian": "Langues asiatiques",
      "african": "Langues africaines"
    }
  },
  "search": {
    "triggerLabel": "Rechercher sur HealthLoop",
    "triggerHint": "Essayez « pas », « pharmacie » ou « grossesse »",
    "triggerAriaLabel": "Ouvrir la recherche globale",
    "placeholder": "Rechercher des fonctionnalités, outils de suivi, aide…",
    "inputAriaLabel": "Rechercher des fonctionnalités HealthLoop",
    "modalAriaLabel": "Recherche HealthLoop",
    "close": "Fermer",
    "clear": "Effacer",
    "clearAriaLabel": "Effacer la recherche",
    "recentSearches": "Recherches récentes",
    "tryFor": "Essayez de rechercher",
    "findFeatures": "Trouvez n'importe quelle fonctionnalité en quelques secondes.",
    "searchAcross": "Rechercher dans",
    "and": "et",
    "sections": {
      "home": "Accueil",
      "nutrition": "Nutrition",
      "family": "Famille",
      "services": "Services",
      "support": "Aide",
      "profile": "Profil"
    },
    "noMatchesFor": "Aucun résultat pour « {{query}} »",
    "trySimpler": "Essayez un mot plus simple comme pas, nutrition ou spécialiste.",
    "comingSoonBadge": "Bientôt disponible",
    "escToClose": "pour fermer",
    "resultSingular": "{{count}} résultat",
    "resultPlural": "{{count}} résultats",
    "searchAcrossApp": "Rechercher dans toute l'application"
  },
  "familyMember": {
    "confirmRemove": "Retirer {{name}} du suivi de santé familial ?",
    "removed": "{{name}} a été retiré de la famille",
    "removeFailed": "Échec du retrait du membre",
    "viewDetails": "Voir les détails",
    "edit": "Modifier",
    "remove": "Retirer",
    "yearsSuffix": "ans",
    "healthGoalsLabel": "Objectifs santé :",
    "moreSuffix": "plus",
    "activeInsights": "Analyses actives",
    "viewAllInsights": "Voir les {{count}} analyses →",
    "viewFullProfile": "Voir le profil santé complet",
    "lifeStage": {
      "infant": "Nourrisson (0-2)",
      "toddler": "Jeune enfant (2-5)",
      "child": "Enfant (6-12)",
      "adolescent": "Ado (13-17)",
      "adult": "Adulte (18-59)",
      "senior": "Senior (60+)",
      "unknown": "Inconnu"
    }
  },
  "profileDeep": {
    "sectionAccount": "Compte",
    "sectionSupport": "Assistance",
    "sectionAbout": "À propos",
    "sectionAdmin": "Administrateur",
    "privacyPolicy": "Politique de confidentialité",
    "terms": "Conditions",
    "appVersion": "Version de l'application",
    "backToDashboard": "Retour au tableau de bord",
    "profileCompletion": "Profil complété",
    "healthSummary": "Bilan santé",
    "sectionA": "Section A",
    "sectionB": "Section B",
    "sectionC": "Section C",
    "sectionD": "Section D",
    "personalDetails": "Informations personnelles",
    "healthInformation": "Informations santé",
    "accountSettings": "Paramètres du compte",
    "fullName": "Nom complet",
    "email": "E-mail",
    "dob": "Date de naissance",
    "gender": "Genre",
    "genderPlaceholder": "ex. Femme, Homme, Non-binaire",
    "height": "Taille (cm)",
    "heightPlaceholder": "ex. 170",
    "weight": "Poids (kg)",
    "weightPlaceholder": "ex. 70",
    "allergies": "Allergies",
    "allergiesPlaceholder": "ex. Arachides",
    "medicalConditions": "Conditions médicales",
    "conditionsPlaceholder": "ex. Hypertension",
    "medications": "Médicaments",
    "medicationsPlaceholder": "ex. Lisinopril 10 mg, quotidien",
    "emergencyContact": "Contact d’urgence",
    "emergencyOptional": "(facultatif)",
    "emergencyPlaceholder": "ex. Maman +33 6 12 34 56 78",
    "emergencyNote": "Inclus dans un partage avec un soignant uniquement si vous l’acceptez.",
    "saveChanges": "Enregistrer",
    "saving": "Enregistrement…",
    "editProfile": "Modifier le profil",
    "cancelEditing": "Annuler la modification",
    "healthScore": "Score santé",
    "streak": "Série",
    "streakDays": "{{n}} jours",
    "memberSince": "Membre depuis",
    "remindersActive": "Rappels actifs",
    "conditionsTracked": "Conditions suivies",
    "nextAgenda": "À l’ordre du jour",
    "notificationsReminders": "Notifications et rappels",
    "notificationsRemindersDesc": "Gérez les horaires et canaux de rappel",
    "emailNudges": "Rappels par e-mail",
    "emailNudgesDesc": "Rappels doux et résumés hebdomadaires",
    "on": "Activés",
    "paused": "En pause",
    "privacySecurity": "Confidentialité et sécurité",
    "privacySecurityDesc": "Mettez à jour votre mot de passe pour protéger votre compte",
    "preferencesTitle": "Préférences",
    "preferencesDesc": "Langue, région et personnalisation",
    "supportHelp": "Aide et assistance",
    "supportHelpDesc": "Obtenez des réponses et contactez-nous",
    "giveFeedback": "Donner un avis",
    "giveFeedbackDesc": "Dites-nous ce que l’on peut améliorer",
    "reportProblem": "Signaler un problème",
    "reportProblemDesc": "Un bug ? Faites-le nous savoir",
    "adminInsights": "Aperçus admin",
    "adminInsightsDesc": "Analyses d’engagement",
    "adminBadge": "Admin",
    "shareWithClinician": "Partager avec un soignant",
    "shareWithClinicianDesc": "Résumé en lecture seule · expire automatiquement · révocable à tout moment",
    "share": "Partager",
    "profileMayBeOutOfDate": "Profil peut-être obsolète",
    "profileMayBeOutOfDateDesc": "Gardez vos données à jour pour des conseils précis — même de petites mises à jour (poids, médicaments) nous aident à adapter vos rappels.",
    "updateNow": "Mettre à jour",
    "profileUpdateError": "Mise à jour impossible. Veuillez réessayer.",
    "healthLoopUser": "Utilisateur HealthLoop",
    "updatedLabel": "Mis à jour",
    "noEntries": "Aucune entrée pour l’instant.",
    "completionComplete": "Votre profil est complet. Nous pouvons vous offrir nos meilleurs conseils. 💚",
    "completionAlmostThere": "Presque fini. Quelques détails encore pour des conseils plus précis.",
    "completionInProgress": "Complétez votre profil pour des conseils bien-être plus pertinents.",
    "justNow": "à l’instant",
    "minAgo": "il y a {{n}} min",
    "minsAgo": "il y a {{n}} min",
    "hourAgo": "il y a {{n}} h",
    "hoursAgo": "il y a {{n}} h",
    "dayAgo": "il y a {{n}} jour",
    "daysAgo": "il y a {{n}} jours",
    "checkinDueToday": "Bilan du jour à faire",
    "checkinDueTonight": "Bilan du soir à faire"
  },
  "supportDeep": {
    "backToSettings": "Retour aux paramètres",
    "quickNavAria": "Sections d’assistance",
    "searchPlaceholder": "Cherchez de l’aide…",
    "searchAria": "Rechercher dans les questions fréquentes",
    "resultsCount": "{{n}} résultat",
    "resultsCountPlural": "{{n}} résultats",
    "questionsCount": "{{n}} questions",
    "liveChatTitle": "Chat en direct",
    "liveChatDesc": "Discutez en temps réel · Lun–Ven 9h–18h",
    "startChat": "Démarrer le chat",
    "liveChatSoonToast": "Le chat en direct arrive bientôt. En attendant, l’e-mail fonctionne très bien.",
    "emailUsTitle": "Nous écrire",
    "emailUsDesc": "Réponse sous 24–48 heures",
    "copy": "Copier",
    "emailCopied": "E-mail copié dans le presse-papier.",
    "contactFormTitle": "Formulaire de contact",
    "contactFormDesc": "Envoyez-nous un message — nous répondons par e-mail.",
    "yourNameLabel": "Votre nom *",
    "namePlaceholder": "Jean Dupont",
    "yourEmailLabel": "Votre e-mail *",
    "emailPlaceholder": "jean@exemple.com",
    "subjectOptional": "Objet (facultatif)",
    "subjectPlaceholder": "En quoi pouvons-nous aider ?",
    "messageLabel": "Message *",
    "messagePlaceholder": "Décrivez brièvement ce dont vous avez besoin.",
    "sending": "Envoi…",
    "sendMessage": "Envoyer",
    "messageSent": "Message envoyé",
    "messageSentDesc": "Nous vous répondrons sous 24–48 heures.",
    "callbackTitle": "Demander un rappel",
    "callbackDesc": "Nous vous rappelons quand cela vous convient.",
    "phoneLabel": "Numéro de téléphone *",
    "phonePlaceholder": "+33 6 12 34 56 78",
    "preferredTimeLabel": "Horaire préféré (facultatif)",
    "preferredTimePlaceholder": "ex. demain après-midi",
    "reasonLabel": "Motif (facultatif)",
    "reasonPlaceholder": "En quelques mots, sur quoi souhaitez-vous échanger ?",
    "submitting": "Envoi…",
    "requestCallback": "Demander un rappel",
    "callbackRequested": "Rappel demandé",
    "callbackRequestedDesc": "Nous vous recontactons sous 24 heures.",
    "medicationSupport": "Suivi des médicaments",
    "medicationSupportDesc": "Suivez ordonnances, renouvellements et rappels.",
    "goToMedications": "Aller aux médicaments →",
    "specialistConsultation": "Consultation spécialisée",
    "specialistConsultationDesc": "Échangez avec un clinicien pour des conseils personnalisés.",
    "connectExpert": "Parler à un expert →",
    "videoConsult": "Téléconsultation",
    "videoConsultDesc": "Réservez une visio avec un spécialiste.",
    "bookConsultation": "Réserver une consultation →",
    "premium": "Premium",
    "healthDisclaimer": "HealthLoop accompagne votre bien-être quotidien — ne remplace pas les soins d’urgence. Si quelque chose vous inquiète, contactez les services d’urgence locaux.",
    "categoryLabel": "Catégorie",
    "catBug": "Bug / Erreur",
    "catPerformance": "Performance lente",
    "catFeature": "Fonctionnalité défaillante",
    "catUi": "Problème d’affichage",
    "catOther": "Autre",
    "issueTitle": "Titre du problème *",
    "issueTitlePlaceholder": "Résumé en une ligne",
    "detailedDescription": "Description détaillée *",
    "detailedDescriptionPlaceholder": "Que s’est-il passé ? Que faisiez-vous ? Les étapes de reproduction nous aident beaucoup.",
    "autoAttachNote": "Les infos d’appareil, navigateur et fenêtre sont jointes automatiquement.",
    "submitReport": "Envoyer le rapport",
    "reportSubmitted": "Rapport envoyé",
    "reportSubmittedDesc": "Notre équipe s’en occupe.",
    "fillAllFields": "Veuillez remplir tous les champs obligatoires",
    "problemReportSubmittedToast": "Rapport envoyé. Nous l’examinons et reviendrons vers vous.",
    "messageSentToast": "Message envoyé. Nous répondons sous 24–48 heures.",
    "callRequestedToast": "Demande de rappel reçue. Nous vous contactons sous 24 heures.",
    "submitFailGeneric": "Échec de l’envoi. Réessayez ou écrivez à {{email}}.",
    "submitFailContact": "Échec de l’envoi. Écrivez directement à {{email}}."
  },
  "careServices": {
    "pageTitle": "Care Services",
    "pageSubtitle": "Clinical and wellness support designed for your everyday health journey.",
    "specialistCareTitle": "Specialist Care",
    "specialistCareSubtitle": "Talk to clinicians and book the right specialist when you need one.",
    "medicationPharmacyTitle": "Medication & Pharmacy",
    "medicationPharmacySubtitle": "Plain-language medication guidance and pharmacy help.",
    "wellnessSupportTitle": "Wellness Support",
    "wellnessSupportSubtitle": "Mental wellness, over-the-counter guidance, and a clear next-step path.",
    "futureWellnessTitle": "Future Wellness Features",
    "futureWellnessSubtitle": "A preview of what's on HealthLoop's preventive-wellness roadmap.",
    "futureFeatureBadge": "Future Feature",
    "futurePersonalizedMealsTitle": "Personalized Meal Plans",
    "futurePersonalizedMealsDesc": "Wellness-led meal plans tuned to your goals, allergies, and culture.",
    "futureHealthyDeliveryTitle": "Healthy Meal Delivery",
    "futureHealthyDeliveryDesc": "Curated delivery from health-conscious kitchens and partners.",
    "futureFarmFreshTitle": "Farm-Fresh Wellness Foods",
    "futureFarmFreshDesc": "Direct access to local farms and seasonal fresh-produce partners.",
    "futureFoodPartnershipsTitle": "Wellness Food Partnerships",
    "futureFoodPartnershipsDesc": "Curated relationships with healthy kitchens, grocers, and wellness brands.",
    "futureNutritionCoachingTitle": "Nutrition Coaching",
    "futureNutritionCoachingDesc": "One-to-one guidance from credentialed nutrition coaches.",
    "futureFamilyWellnessTitle": "Family Wellness Plans",
    "futureFamilyWellnessDesc": "Shared plans that keep the whole household on track.",
    "futureWellnessPlusTitle": "Wellness+ Membership",
    "futureWellnessPlusDesc": "A premium tier for personalised guidance, priority support, and deeper insights.",
    "futurePharmacyPartnersTitle": "Pharmacy Partnerships",
    "futurePharmacyPartnersDesc": "Trusted pharmacy connections for medication guidance and refills.",
    "futureAdvancedSpecialistTitle": "Advanced Specialist Care",
    "futureAdvancedSpecialistDesc": "Coordinated access to specialists, second opinions, and care navigation.",
    "futureWellnessMarketplaceTitle": "Wellness Marketplace",
    "futureWellnessMarketplaceDesc": "A curated marketplace of vetted wellness products and services.",
    "futureVendorCollabTitle": "Vendor Collaboration Systems",
    "futureVendorCollabDesc": "Onboarding and quality systems for healthy food and wellness partners."
  },
  "dashboardDeep": {
    "recsSummary": {
      "excellent": "Tout est en place pour aujourd'hui — continuez sur ce rythme.",
      "good": "{{done}} sur {{total}} fait • quelques petits gestes restent",
      "improvable": "{{done}} sur {{total}} fait • deux améliorations augmenteraient votre score",
      "needsAttention": "{{done}} sur {{total}} fait • commencez par une priorité ci-dessous"
    },
    "priorityBadge": "Prioritaire",
    "factor": {
      "water": "hydratation",
      "meals": "nutrition",
      "steps": "mouvement",
      "sleep": "sommeil"
    },
    "rec": {
      "water": {
        "priority": {
          "title": "Hydratation faible — commencez par un verre maintenant",
          "description": "Votre hydratation est bien en dessous de l'objectif. Un verre dans l'heure aide à se rétablir."
        },
        "improvement": {
          "title": "Améliorez votre hydratation aujourd'hui",
          "description": "Visez 6 à 8 verres d'eau au cours de la journée pour rester énergique."
        },
        "maintenance": {
          "title": "Restez hydraté",
          "description": "Maintenez votre apport régulier en eau jusqu'à la fin de la journée."
        }
      },
      "meals": {
        "priority": {
          "title": "Un repas équilibré est votre prochaine étape",
          "description": "La nutrition est légère aujourd'hui. Un repas avec légumes et protéines aidera bientôt."
        },
        "improvement": {
          "title": "Complétez votre nutrition aujourd'hui",
          "description": "Incluez des fruits, légumes ou un repas équilibré à votre prochain repas."
        },
        "maintenance": {
          "title": "Maintenez une nutrition équilibrée",
          "description": "Continuez d'inclure fruits et légumes — vous le faites bien."
        }
      },
      "steps": {
        "priority": {
          "title": "Activité faible — une courte marche maintenant aide",
          "description": "Même 10 minutes de mouvement augmentera votre énergie pour la soirée."
        },
        "improvement": {
          "title": "Ajoutez du mouvement aujourd'hui",
          "description": "Visez 5 000 à 10 000 pas par jour, à votre propre rythme."
        },
        "maintenance": {
          "title": "Restez actif",
          "description": "Continuez à bouger doucement pour maintenir votre rythme."
        }
      },
      "sleep": {
        "priority": {
          "title": "La récupération a besoin d'attention ce soir",
          "description": "Détendez-vous un peu plus tôt — visez 7 à 8 heures pour rétablir votre équilibre."
        },
        "improvement": {
          "title": "Visez un sommeil réparateur ce soir",
          "description": "Ciblez 7 à 8 heures de repos pour soutenir demain."
        },
        "maintenance": {
          "title": "Protégez votre sommeil",
          "description": "Maintenez vos 7 à 8 heures ce soir — la récupération est essentielle."
        }
      }
    },
    "insight": {
      "allOnTrack": "Hydratation, nutrition, mouvement et repos — tout est sur la bonne voie aujourd'hui. C'est le genre de journée qui construit une santé durable.",
      "singlePending": "Votre {{factor}} est le seul facteur encore en attente aujourd'hui. Un petit pas maintenant maintient votre rythme.",
      "pairLowScore": "Votre {{factors}} sont tous deux faibles aujourd'hui. En améliorer un est le moyen le plus rapide de mieux se sentir ce soir.",
      "pairOk": "Votre {{factors}} ont tous deux besoin d'un petit coup de pouce aujourd'hui. Ils évoluent souvent ensemble — améliorer l'un aide souvent l'autre.",
      "pair": {
        "water+sleep": {
          "v1": "L'hydratation et le sommeil sont les deux facteurs les plus souvent liés à la concentration. Les améliorer tous deux aujourd'hui stabilise généralement demain.",
          "v2": "Quand l'hydratation et le sommeil sont bas ensemble, l'énergie suit. Un verre d'eau maintenant et un coucher plus tôt aideront."
        },
        "water+meals": {
          "v1": "L'hydratation et les repas équilibrés sont encore en attente aujourd'hui. Ensemble, c'est le levier le plus facile pour une énergie stable.",
          "v2": "Des repas légers et peu d'eau provoquent souvent des baisses en milieu d'après-midi. Un petit ajustement change la courbe."
        },
        "water+steps": {
          "v1": "L'hydratation et le mouvement se renforcent — l'eau vous prépare à bouger, le mouvement vous garde alerte.",
          "v2": "Un verre d'eau et une courte marche sont les deux interventions les plus simples pour la suite de votre journée."
        },
        "meals+sleep": {
          "v1": "La nutrition influence votre sommeil, et le sommeil influence votre alimentation. Aujourd'hui est l'occasion d'améliorer les deux.",
          "v2": "Des repas équilibrés et 7 à 8 heures de repos sont la combinaison la plus simple pour la résilience. Visez les deux aujourd'hui."
        },
        "meals+steps": {
          "v1": "Le mouvement et les repas équilibrés ensemble sont l'un des signaux les plus forts pour la santé à long terme.",
          "v2": "Une marche de 10 minutes après votre prochain repas favorise les deux en même temps."
        },
        "steps+sleep": {
          "v1": "L'activité plus tôt dans la journée mène généralement à un sommeil plus profond. Les deux sont en attente — ils s'aident mutuellement.",
          "v2": "Mouvement maintenant, repos ce soir. Ils se renforcent davantage qu'on ne le pense."
        }
      }
    },
    "exploreCareServicesTitle": "Explorez les services",
    "exploreCareServicesSubtitle": "Découvrez des recommandations bien-être adaptées à votre quotidien.",
    "healthProfile": "Profil santé",
    "notifications": "Notifications",
    "familyAccounts": "Comptes famille",
    "settings": "Paramètres",
    "logout": "Déconnexion",
    "allCaughtUp": "Vous êtes à jour.",
    "weekInReview": "Votre semaine en revue",
    "dismissNotification": "Ignorer la notification",
    "dismissWeeklyDigest": "Ignorer le résumé hebdomadaire",
    "notificationsAria": "Notifications",
    "profileMenuAria": "Ouvrir le menu profil",
    "loadingWellness": "Chargement de votre bilan bien-être",
    "nextTip": "Astuce suivante",
    "todayAtGlance": "Aujourd’hui d’un coup d’œil",
    "healthScoreLabel": "Score santé",
    "currentStreakLabel": "Série actuelle",
    "todaysProgress": "Progrès du jour",
    "insightForYou": "Conseil pour vous",
    "checkMyHealthRisk": "Vérifier mon risque santé",
    "quickAccess": "Accès rapide",
    "familyCare": "Soins famille",
    "healthLibrary": "Bibliothèque santé",
    "myHealthData": "Mes données santé",
    "askQuestion": "Poser une question",
    "dashLoadError": "Impossible de charger votre tableau de bord. Réessayez.",
    "taskUpdateError": "Mise à jour impossible. Réessayez.",
    "perfectDay": "Journée parfaite ! 🎉 Série prolongée.",
    "letsStart": "C’est parti",
    "yourNextStepToday": "Votre prochaine étape",
    "completeDailyCheck": "Faites votre bilan santé du jour",
    "startDailyCheck": "Lancer le bilan",
    "viewAll": "Voir tout",
    "graceProtected": "Période de grâce active",
    "todaysHealthRecommendations": "Recommandations santé du jour",
    "updateViaCheck": "Mettre à jour via le bilan",
    "healthInsight": "Conseil santé",
    "riskCheckSubtext": "Recevez des conseils santé personnalisés en quelques secondes",
    "foodDiet": "Alimentation",
    "healthScoreNew": "Score santé · Nouveau",
    "letsBuildScore": "Construisons votre score santé ensemble",
    "oneHealthyHabitAtATime": "Une habitude saine à la fois.",
    "nextCheck": "Prochain bilan :",
    "todayAt8pm": "aujourd’hui à 20 h",
    "wellnessTipForYou": "Astuce bien-être du jour · Pour vous",
    "wellnessTipForFactor": "Astuce bien-être du jour · Pour votre {{factor}}",
    "logged": "Enregistré",
    "gotIt": "Compris 👍",
    "gladToSeeYou": "Ravis de vous voir aujourd’hui 💚",
    "takesLessThan60Sec": "Moins de 60 secondes",
    "scoreReadyWhenYou": "Prêt quand vous l’êtes",
    "scoreCompleteFirstCheck": "Faites votre premier bilan pour débloquer des conseils personnalisés.",
    "scoreExcellent": "Excellent",
    "scoreSupportExcellent": "Vous êtes en pleine forme aujourd’hui. Continuez !",
    "scoreGood": "Bon",
    "scoreSupportGood": "Vous tenez bon. Maintenez vos bonnes habitudes.",
    "scoreModerate": "Modéré",
    "scoreSupportModerate": "Cela va, mais quelques points méritent attention.",
    "scoreNeedsAttention": "À surveiller",
    "scoreSupportNeedsAttention": "Votre santé demande attention aujourd’hui. De petits changements peuvent aider."
  },
  "emailVerify": {
    "bannerWithEmail": "Veuillez vérifier votre e-mail ({{email}}) afin que nous sécurisions votre compte et que vous receviez vos rappels.",
    "bannerNoEmail": "Veuillez vérifier votre e-mail afin que nous sécurisions votre compte et que vous receviez vos rappels.",
    "sending": "Envoi…",
    "resend": "Renvoyer l’e-mail",
    "sentToast": "E-mail de vérification envoyé. Consultez votre boîte de réception.",
    "sendFailToast": "Impossible d’envoyer l’e-mail de vérification. Réessayez plus tard."
  },
  "forgotPassword": {
    "title": "Mot de passe oublié ?",
    "subtitle": "Pas de souci ! Entrez votre e-mail et nous vous enverrons les instructions.",
    "emailLabel": "Adresse e-mail",
    "emailPlaceholder": "votre.email@exemple.com",
    "sendResetLink": "Envoyer le lien",
    "sending": "Envoi…",
    "backToLogin": "Retour à la connexion",
    "resendLink": "Renvoyer l’e-mail",
    "successTitle": "Consultez votre e-mail",
    "successBody": "Si un compte existe pour {{email}}, nous avons envoyé un lien de réinitialisation.",
    "linkExpires": "Le lien expirera dans 30 minutes.",
    "successToast": "Consultez votre e-mail pour les instructions de réinitialisation",
    "errEmptyEmail": "Veuillez saisir votre adresse e-mail",
    "errInvalidEmail": "Veuillez saisir une adresse e-mail valide",
    "errNetwork": "Impossible de joindre le serveur. Vérifiez votre connexion et réessayez.",
    "errGeneric": "Échec de l’envoi. Réessayez ou contactez le support."
  },
  "resetPassword": {
    "title": "Nouveau mot de passe",
    "subtitle": "Créez un mot de passe fort pour votre compte",
    "newPasswordLabel": "Nouveau mot de passe",
    "newPasswordPlaceholder": "Entrez le nouveau mot de passe",
    "confirmPasswordLabel": "Confirmer le mot de passe",
    "confirmPasswordPlaceholder": "Confirmez le nouveau mot de passe",
    "requirementsHint": "8 caractères minimum, avec majuscule, minuscule et chiffre",
    "resetPassword": "Réinitialiser",
    "resetting": "Réinitialisation…",
    "successTitle": "Mot de passe réinitialisé !",
    "successBody": "Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
    "successToast": "Mot de passe réinitialisé avec succès !",
    "goToLogin": "Aller à la connexion",
    "invalidLinkTitle": "Lien invalide",
    "invalidLinkBody": "Ce lien de réinitialisation est invalide ou a expiré.",
    "requestNewLink": "Demander un nouveau lien",
    "showPassword": "Afficher le mot de passe",
    "hidePassword": "Masquer le mot de passe",
    "errInvalidLink": "Lien de réinitialisation invalide",
    "errMismatch": "Les mots de passe ne correspondent pas",
    "errTooShort": "Le mot de passe doit contenir au moins 8 caractères",
    "errExpiredToken": "Ce lien a expiré ou est invalide. Demandez-en un nouveau.",
    "errNetwork": "Impossible de joindre le serveur. Vérifiez votre connexion et réessayez.",
    "errGeneric": "Échec de la réinitialisation. Réessayez."
  },
  "tips": {
    "water1": "Boire de l’eau dans les 30 minutes après le réveil peut améliorer l’hydratation et l’énergie.",
    "water2": "Un verre d’eau avant chaque repas est une façon douce de garder une longueur d’avance sur la soif.",
    "water3": "Une tranche de citron ou quelques feuilles de menthe transforment l’hydratation en plaisir.",
    "meals1": "Une portion supplémentaire de légumes par jour soutient la santé intestinale et cardiaque.",
    "meals2": "Une poignée de noix ou de graines au petit-déjeuner stabilise votre énergie le matin.",
    "meals3": "Le fruit entier vaut mieux que le jus — la fibre adoucit l’effet sur la glycémie.",
    "steps1": "Une marche de 10 minutes après les repas aide votre corps à mieux gérer les sucres.",
    "steps2": "Un étirement de 5 minutes le matin apaise les tensions et donne un ton calme à la journée.",
    "steps3": "Prendre les escaliers une fois par jour renforce discrètement le cœur au fil des semaines.",
    "sleep1": "Tamiser la lumière une heure avant le coucher aide votre corps à se préparer à un sommeil plus profond.",
    "sleep2": "Un horaire de réveil régulier — même le week-end — stabilise votre cycle de sommeil.",
    "sleep3": "10 minutes de lumière matinale aident à réguler votre rythme veille-sommeil naturellement.",
    "general1": "Deux minutes de respiration lente peuvent réduire le stress et apaiser la concentration.",
    "general2": "Remarquez un moment de gratitude aujourd’hui — les petites victoires mentales s’accumulent aussi.",
    "general3": "Vous êtes là aujourd’hui. C’est l’habitude qui rend toutes les autres plus faciles."
  },
  "factors": {
    "hydration": "hydratation",
    "nutrition": "nutrition",
    "movement": "mouvement",
    "sleep": "sommeil"
  },
  "nutritionDeep": {
    "sectionSnapshot": "Résumé nutritionnel quotidien",
    "sectionSnapshotSubtitle": "Un coup d'œil rapide sur l'hydratation, les calories et l'équilibre des repas du jour.",
    "mealOptionsLoadFail": "Échec du chargement des options de repas",
    "prefsSaved": "Préférences enregistrées ! Mise à jour des repas...",
    "prefsSaveFail": "Échec de l’enregistrement des préférences",
    "newOptionsFail": "Échec du chargement de nouvelles options",
    "invalidZip": "Saisissez un code postal à 5 chiffres valide",
    "noVendorsArea": "Aucun vendeur disponible dans cette zone. Nous étendons la couverture !",
    "vendorsFetchFail": "Échec du chargement des vendeurs",
    "selectVendorFirst": "Sélectionnez d’abord un vendeur",
    "removedFromCart": "Retiré du panier",
    "orderPlaced": "Commande passée avec succès ! 🎉",
    "enterZipFirst": "Saisissez d’abord votre code postal dans la section livraison",
    "mealNotAvailable": "Ce repas n’est pas encore livrable dans votre zone",
    "mealUnavailable": "Ce repas est indisponible chez les vendeurs proches",
    "vendorOptionsFail": "Échec du chargement des vendeurs",
    "favoriteSaveFail": "Échec de l’enregistrement du favori",
    "removedFromFavorites": "Retiré des favoris",
    "favoriteRemoveFail": "Échec de la suppression du favori",
    "cartEmpty": "Votre panier est vide",
    "noMealOptions": "Aucune option de repas disponible",
    "loadingOptions": "Chargement des options de repas...",
    "selectPreferences": "Choisissez vos préférences alimentaires",
    "mealBuilder": "Composer un repas",
    "myFavorites": "Mes favoris",
    "myFavoriteMeals": "Mes repas favoris",
    "noFavoritesYet": "Aucun repas favori pour l’instant !",
    "price": "Prix",
    "delivery": "Livraison",
    "deliveryFee": "Frais de livraison",
    "distance": "Distance",
    "subtotal": "Sous-total",
    "total": "Total",
    "orderNumber": "Numéro de commande",
    "vendor": "Vendeur",
    "totalAmount": "Montant total",
    "estimatedDelivery": "Livraison estimée",
    "whyThisMeal": "Pourquoi ce repas",
    "selectThisMeal": "Choisir ce repas",
    "swapMeal": "Changer de repas",
    "orderThisMeal": "Commander ce repas",
    "notAvailableNearYou": "Non disponible près de chez vous",
    "tryAdjustingPrefs": "Ajustez vos préférences alimentaires pour voir des suggestions",
    "myMealPlanSummary": "Mon plan de repas",
    "saveCompletePlan": "Enregistrer le plan",
    "yourFoodPreferences": "Vos préférences alimentaires",
    "editPreferences": "Modifier les préférences",
    "healthyMealDelivery": "Livraison de repas santé",
    "enableDelivery": "Activer la livraison",
    "enterZipCode": "Entrez votre code postal pour voir les repas disponibles",
    "savePreferences": "Enregistrer les préférences",
    "quickAccessSavedMeals": "Accès rapide à vos repas enregistrés",
    "saveMealsFromBuilder": "Enregistrez des repas depuis l’onglet Composer",
    "chooseVendor": "Choisissez un vendeur pour commander ce repas",
    "yourCart": "Votre panier",
    "addMealsToStart": "Ajoutez des repas depuis les options ci-dessous",
    "orderPlacedDesc": "Votre commande de repas santé a été passée avec succès",
    "continueShopping": "Continuer mes achats",
    "trackOrder": "Suivre la commande",
    "healthyStoresTitle": "Épiceries santé et marchés bien-être",
    "healthyStoresIntro": "Types de commerces inclusifs à découvrir — pour vous inspirer, pas pour la livraison.",
    "culturalNutritionTitle": "Conseils d'achats santé",
    "culturalNutritionSubtitle": "Idées générales et culturellement inclusives pour des achats sains — uniquement éducatif, ce n'est pas un annuaire de vendeurs ou de livraison en direct.",
    "shoppingGuidanceScope": "Les listes de vendeurs locaux certifiés ne sont pas encore disponibles. Vous pouvez tout de même explorer ci-dessous les conseils généraux d'achats santé.",
    "popularWellnessTitle": "Aliments bien-être populaires",
    "popularWellnessIntro": "Ingrédients culturellement pertinents et types d'environnements alimentaires sains à explorer.",
    "subsectionLocalEnvironmentTitle": "Environnements alimentaires sains",
    "subsectionLocalEnvironmentIntro": "Types d'endroits où l'on trouve souvent des options saines et culturellement pertinentes.",
    "healthyStoresGuidanceTitle": "Conseils pour des courses saines",
    "healthyStoresDisclaimer": "HealthLoop partage uniquement des inspirations de bien-être général et d'alimentation saine — ceci ne constitue pas un conseil en nutrition ou en santé.",
    "healthyStores": {
      "organic": {
        "type": "Épiceries biologiques",
        "description": "Produits frais sans pesticides et produits de base peu transformés.",
        "tags": [
          "Produits bruts",
          "Produits frais"
        ]
      },
      "farmers": {
        "type": "Marchés de producteurs",
        "description": "Fruits et légumes de saison locaux, et produits traditionnels directement des cultivateurs.",
        "tags": [
          "Local",
          "De saison"
        ]
      },
      "african": {
        "type": "Épiceries de produits frais africains",
        "description": "Ignames, bananes plantains, légumes-feuilles, noix de palme et produits de base d'Afrique de l'Est et de l'Ouest.",
        "tags": [
          "Culturel",
          "Produits frais"
        ]
      },
      "caribbean": {
        "type": "Marchés de produits naturels des Caraïbes",
        "description": "Callaloo, manioc, piment antillais, akée, fruit à pain et essentiels des îles.",
        "tags": [
          "Culturel",
          "Produits bruts"
        ]
      },
      "asian": {
        "type": "Supermarchés de légumes asiatiques",
        "description": "Bok choy, daikon, racine de lotus, tofu, herbes fraîches et essentiels panasiatiques.",
        "tags": [
          "Culturel",
          "Produits frais"
        ]
      },
      "halal": {
        "type": "Marchés d'alimentation saine Halal",
        "description": "Protéines maigres certifiées Halal, produits frais et épices traditionnelles.",
        "tags": [
          "Halal",
          "Culturel"
        ]
      },
      "mediterranean": {
        "type": "Marchés de produits bruts méditerranéens",
        "description": "Huile d'olive, légumineuses, herbes fraîches, céréales complètes et essentiels méditerranéens.",
        "tags": [
          "Culturel",
          "Produits bruts"
        ]
      },
      "wellness": {
        "type": "Épiceries orientées bien-être",
        "description": "Sélection de produits bruts, options végétales et articles de garde-manger à composition propre.",
        "tags": [
          "Produits bruts",
          "Végétal"
        ]
      }
    },
    "healthyShoppingTips": [
      "Faites d'abord le tour du magasin — les produits frais, les protéines maigres et les alternatives végétales se trouvent souvent en périphérie.",
      "Privilégiez les aliments bruts à ingrédient unique plutôt que les produits ultra-transformés.",
      "Choisissez des produits locaux de saison — souvent plus frais, plus abordables et plus riches en nutriments.",
      "Interrogez les vendeurs sur l'origine et les méthodes de culture — beaucoup seront ravis de partager."
    ]
  },
  "messages": {
    "success": "Succès!",
    "error": "Erreur",
    "saved": "Enregistré avec succès",
    "updated": "Mis à jour avec succès",
    "deleted": "Supprimé avec succès",
    "confirmDelete": "Êtes-vous sûr de vouloir supprimer ceci?",
    "networkError": "Erreur réseau. Veuillez réessayer.",
    "somethingWrong": "Quelque chose s'est mal passé",
    "failedToLoad": "Échec du chargement du tableau de bord",
    "offlineMode": "Mode hors ligne - affichage de données limitées",
    "locationDenied": "Accès à la localisation refusé. Vérifiez les paramètres du navigateur pour activer.",
    "locationUnavailable": "Informations de localisation indisponibles",
    "locationTimeout": "Délai de demande de localisation expiré. Veuillez réessayer.",
    "locationError": "Impossible d'accéder à la localisation",
    "locationGranted": "Accès à la localisation accordé! Affichage des options à proximité",
    "locationNotSupported": "Services de localisation non pris en charge par votre navigateur",
    "requestingLocation": "Demande d'accès à la localisation..."
  },
  "trust": {
    "medicalDisclaimer": "Medical Disclaimer",
    "privacySecure": "Your data is private & secure",
    "dataEncrypted": "All data is encrypted and confidential",
    "notMedicalAdvice": "Not medical advice",
    "consultProvider": "Always consult your healthcare provider",
    "evidenceBased": "Evidence-based guidance",
    "generalEducation": "General health education",
    "preventiveGuidance": "Preventive guidance",
    "lifestyleSupport": "For awareness and lifestyle support",
    "lastUpdated": "Last updated",
    "expertReviewed": "Expert reviewed",
    "aiGenerated": "AI-generated insight",
    "disclaimerShort": "HealthLoop provides health education and is not a substitute for professional medical advice.",
    "disclaimerFull": "HealthLoop supports preventive wellness and early awareness. We provide health education, habit tracking, and wellness insights. This is not a substitute for licensed medical care. Always consult qualified healthcare providers for medical advice, diagnosis, or treatment.",
    "trustBanner": {
      "title": "HealthLoop is here to support your wellness journey",
      "description": "We provide general health education and preventive guidance based on trusted sources. This is not a substitute for professional medical advice. Always consult with qualified healthcare providers for medical decisions."
    }
  },
  "health": {
    "preventiveHealth": "Suivi de la Santé Préventive",
    "educationHub": "Centre d'Éducation",
    "engagementWidget": "Widget d'Engagement",
    "wellnessCheckIn": "Enregistrement du Bien-être",
    "todaysMetrics": "Métriques d'Aujourd'hui",
    "bloodPressure": "Pression Artérielle",
    "heartRate": "Fréquence Cardiaque",
    "weight": "Poids",
    "sleep": "Sommeil",
    "waterIntake": "Consommation d'Eau",
    "exercise": "Exercice",
    "logMetric": "Enregistrer la Métrique",
    "viewHistory": "Voir l'Historique"
  },
  "aiInsights": {
    "title": "AI Health Insights",
    "comingSoon": "Your insights are gathering",
    "comingSoonDesc": "Complete a daily check-in or two and we'll surface gentle, personalised insights here.",
    "learnMore": "Learn more",
    "evidenceSources": {
      "WHO": "Based on WHO guidelines",
      "NHS": "Aligned with NHS recommendations",
      "CDC": "Supported by CDC guidelines",
      "RESEARCH": "Based on peer-reviewed research",
      "CLINICAL": "Backed by clinical studies"
    }
  },
  "dailyInsight": {
    "title": "Daily Health Insight",
    "gettingStarted": "Getting Started",
    "focus": "Focus",
    "quickInsight": "Quick Insight",
    "simpleExplanation": "Simple Explanation",
    "realLifeImpact": "Real-Life Impact",
    "yourActionStep": "Your Action Step",
    "basedOnYour": "Based on your",
    "personalizedFor": "Personalized for you based on your recent health data",
    "getNewInsight": "Get new insight",
    "newInsightLoaded": "New insight loaded! 💡",
    "failedToRefresh": "Failed to refresh insight",
    "priority": {
      "high": "Let's Focus Here",
      "medium": "Worth Noting"
    }
  },
  "preventiveAlerts": {
    "noAlertsTitle": "No health alerts at this time",
    "noAlertsDesc": "You're maintaining healthy habits. Keep it up!",
    "whatYouCanDo": "What you can do:",
    "viewMealSuggestions": "View Personalized Meal Suggestions"
  },
  "engagement": {
    "currentStreak": "Current Streak",
    "bestStreak": "Best Streak",
    "thisWeek": "This Week",
    "exerciseDays": "Exercise Days",
    "hydrationDays": "Hydration Days",
    "healthMetricsLogged": "Health Metrics Logged",
    "weeklyGoalsProgress": "Weekly Goals Progress",
    "completed": "completed",
    "days": "days",
    "keepGoing": "Keep going!",
    "personalRecord": "Personal record!",
    "goalMet": "Goal met!"
  },
  "reminders": {
    "title": "Rappels de Santé",
    "subtitle": "Restez sur la bonne voie avec des notifications de santé personnalisées",
    "breakfast": "Rappel du Petit-déjeuner",
    "lunch": "Rappel du Déjeuner",
    "dinner": "Rappel du Dîner",
    "water": "Consommation d'Eau",
    "movement": "Pause Mouvement",
    "sleep": "Rappel de Sommeil",
    "wellness": "Enregistrement du Bien-être",
    "healthLogging": "Enregistrement de la Santé",
    "annualCheckup": "Bilan Annuel",
    "enable": "Activer",
    "disable": "Désactiver",
    "customize": "Personnaliser l'Heure",
    "stayConsistent": "Stay Consistent with Smart Reminders",
    "setupFriendly": "Set up friendly reminders to help you build healthy habits.",
    "customizeWhen": "You can customize when and how often you receive each reminder.",
    "supportive": "Don't worry - we'll keep them supportive and non-intrusive! 💚",
    "noPreferences": "No Reminder Preferences Found",
    "noPreferencesDesc": "We couldn't load your reminder settings. This might be your first time here, or there was an issue loading your preferences.",
    "retryLoading": "Retry Loading",
    "saveSettings": "Save Settings",
    "saving": "Saving..."
  },
  "empty": {
    "startJourney": "Start Your Wellness Journey",
    "startJourneyDesc": "Start your health journey today! Share how you're feeling to receive personalized insights and track your wellness over time.",
    "completeFirstCheckIn": "Complete First Check-in",
    "stayOnTrack": "Stay On Track",
    "stayOnTrackDesc": "Stay consistent with your routine 💊 Add your medications to get gentle reminders and support.",
    "addFirstMedication": "Add First Medication",
    "learnMedicationSafety": "Learn About Medication Safety",
    "buildMealLibrary": "Build Your Meal Library",
    "buildMealLibraryDesc": "No favorite meals yet. Save meals you love for quick access and easier meal planning.",
    "exploreMealOptions": "Explore Meal Options",
    "insightsAwait": "Your Insights Await",
    "insightsAwaitDesc": "Complete daily check-ins and track your wellness to unlock personalized health insights and pattern analysis.",
    "startDailyCheckIn": "Start Daily Check-in",
    "learnAboutInsights": "Learn About Insights",
    "buildingStory": "Building Your Wellness Story",
    "buildingStoryDesc": "No historical data yet. Your wellness trends and patterns will appear here as you complete daily check-ins.",
    "completeCheckIn": "Complete Check-in",
    "tipComplete7Days": "Tip: Complete check-ins for 7 days to see meaningful trends and patterns.",
    "startTrackingHabits": "Start Tracking Healthy Habits",
    "startTrackingHabitsDesc": "No habits tracked yet. Small daily actions create lasting wellness changes. Begin building your healthy routine today.",
    "trackFirstHabit": "Track First Habit",
    "getMoving": "Get Moving",
    "getMovingDesc": "No activity logged yet. Even 10 minutes of movement can boost your mood and energy.",
    "logActivity": "Log Activity",
    "allCaughtUp": "All Caught Up!",
    "allCaughtUpDesc": "You have no new notifications. Check back later for updates and wellness reminders.",
    "noResultsFound": "No Results Found",
    "noResultsFoundDesc": "We couldn't find any results for \"{query}\". Try adjusting your search or explore other options."
  },
  "footer": {
    "tagline": "Your AI-Powered Preventive Health Companion",
    "builtWith": "Built with care for your wellness journey",
    "allRightsReserved": "All rights reserved.",
    "about": "About",
    "privacy": "Privacy",
    "terms": "Terms",
    "contact": "Contact",
    "helpCenter": "Help Center"
  },
  "modals": {
    "feedback": {
      "title": "Share Your Feedback",
      "subtitle": "Help us improve HealthLoop",
      "whatWorking": "What's working well?",
      "whatImprove": "What could we improve?",
      "placeholder": "Share your thoughts...",
      "thankYou": "Thank you for your feedback!",
      "submitted": "Your feedback helps us make HealthLoop better."
    },
    "reportProblem": {
      "title": "Report a Problem",
      "subtitle": "Help us fix bugs and improve the app",
      "describe": "Describe the issue",
      "placeholder": "What happened? Please be as specific as possible...",
      "optional": "Optional: Steps to reproduce",
      "stepsPlaceholder": "1. I clicked on...\n2. Then I...",
      "thankYou": "Thank you for reporting!",
      "submitted": "We'll look into this right away."
    },
    "mealPreferences": {
      "title": "Customize Your Meals",
      "subtitle": "Tell us about your food preferences",
      "cuisines": "Preferred Cuisines",
      "selectCuisines": "Select all that apply",
      "dietary": "Dietary Preferences",
      "selectDietary": "Select your dietary needs",
      "allergies": "Allergies & Restrictions",
      "allergiesPlaceholder": "e.g., Nuts, Shellfish, Gluten",
      "save": "Save Preferences",
      "saving": "Saving..."
    },
    "upgrade": {
      "title": "Upgrade to Premium",
      "subtitle": "Unlock all features",
      "features": "Premium Features",
      "getStarted": "Get Started",
      "learnMore": "Learn More"
    }
  },
  "login": {
    "title": "Your Preventive Health Intelligence Platform",
    "subtitle": "Track, learn, and take action before problems escalate. Built for prevention, education, engagement, and wellness.",
    "email": "Email",
    "password": "Password",
    "signIn": "Sign In",
    "signingIn": "Signing in...",
    "forgotPassword": "Forgot Password?",
    "noAccount": "Don't have an account?",
    "createAccount": "Create one",
    "biometricLogin": "Sign in with Biometrics",
    "biometricHelper": "Use fingerprint, Face ID, or Windows Hello",
    "authenticating": "Authenticating...",
    "vendorPartner": "Are you a vendor partner?",
    "vendorLogin": "Vendor Login",
    "emailRequired": "Please enter your email first",
    "biometricSuccess": "Successfully signed in with biometrics! 🎉",
    "noPasskeys": "No biometric login set up. Please use password login first.",
    "biometricCancelled": "Biometric login cancelled",
    "biometricFailed": "Biometric login failed. Please try password login."
  },
  "register": {
    "title": "Rejoignez HealthLoop",
    "subtitle": "Commencez votre parcours de santé préventive dès aujourd’hui",
    "fullName": "Nom complet",
    "email": "E-mail",
    "password": "Mot de passe",
    "confirmPassword": "Confirmer le mot de passe",
    "createAccount": "Créer un compte",
    "haveAccount": "Vous avez déjà un compte ?",
    "signIn": "Se connecter",
    "creating": "Création du compte...",
    "passwordTooShort": "Le mot de passe doit comporter au moins 8 caractères",
    "setupBiometric": "Configurer la connexion biométrique",
    "setupBiometricDesc": "Utilisez votre empreinte digitale, Face ID ou Windows Hello pour une connexion plus rapide et sécurisée",
    "setupNow": "Configurer maintenant",
    "skipForNow": "Plus tard",
    "settingUp": "Configuration...",
    "benefit1": "Plus besoin de mémoriser les mots de passe",
    "benefit2": "Sécurité renforcée grâce à la biométrie",
    "benefit3": "Connexion en un simple geste ou regard",
    "biometricPrivacy": "Vos données biométriques restent sur votre appareil",
    "biometricSuccess": "Connexion biométrique configurée ! 🎉",
    "biometricFailed": "Échec de la configuration biométrique. Vous pourrez la configurer plus tard dans les paramètres.",
    "biometricSetupLater": "Vous pourrez configurer la connexion biométrique plus tard dans votre profil"
  },
  "womensHealthPage": {
    "title": "Women's Health Tracker",
    "subtitle": "Track your cycle, symptoms, and wellness",
    "cycleOverview": "Cycle Overview",
    "currentPhase": "Current Phase",
    "nextPeriod": "Next Period Expected",
    "logPeriod": "Log Period",
    "logSymptoms": "Log Symptoms",
    "insights": "Cycle Insights",
    "tips": "Phase-Based Tips",
    "history": "Period History",
    "noData": "No cycle data yet",
    "noDataDesc": "Start tracking your cycle to receive personalized insights and predictions.",
    "startTracking": "Start Tracking"
  },
  "notifications": {
    "title": "Notifications",
    "markAllRead": "Mark All as Read",
    "noNotifications": "No new notifications",
    "viewAll": "View All"
  },
  "familyHealth": {
    "title": "Family & Child Health",
    "subtitle": "Preventive health support for your entire family",
    "tabImmunizations": "Immunizations",
    "tabEducation": "Education",
    "tabReminders": "Reminders",
    "tabPlanner": "Family Planner",
    "immunizations": {
      "title": "Immunization Awareness",
      "subtitle": "Stay informed about recommended vaccines",
      "recommendedSchedule": "Recommended Schedule",
      "byAge": "By Age Group",
      "infants": "Infants (0-12 months)",
      "toddlers": "Toddlers (1-3 years)",
      "preschool": "Preschool (4-6 years)",
      "schoolAge": "School Age (7-12 years)",
      "teens": "Teens (13-18 years)",
      "adults": "Adults",
      "learnMore": "Learn More",
      "consultDoctor": "Always consult your healthcare provider for personalized vaccine recommendations",
      "upcomingReminders": "Upcoming Vaccine Reminders",
      "noReminders": "No upcoming vaccine reminders",
      "addReminder": "Add Vaccine Reminder",
      "reminderFor": "Reminder for",
      "dueDate": "Due Date",
      "notes": "Notes",
      "markComplete": "Mark Complete"
    },
    "education": {
      "title": "Family Health Education",
      "subtitle": "Evidence-based preventive health information",
      "categories": "Categories",
      "infant": "Infant Care",
      "child": "Child Development",
      "nutrition": "Nutrition & Growth",
      "safety": "Safety & Prevention",
      "mental": "Mental Wellness",
      "hygiene": "Hygiene & Habits",
      "searchPlaceholder": "Search health topics...",
      "popularTopics": "Popular Topics",
      "readMore": "Read More",
      "readTime": "min read"
    },
    "reminders": {
      "title": "Family Health Reminders",
      "subtitle": "Stay on track with preventive care for the whole family",
      "createReminder": "Create Reminder",
      "familyMember": "Family Member",
      "reminderType": "Reminder Type",
      "frequency": "Frequency",
      "activeReminders": "Active Reminders",
      "upcomingThisWeek": "Upcoming This Week",
      "noActiveReminders": "No active reminders",
      "types": {
        "checkup": "Health Checkup",
        "dental": "Dental Visit",
        "vision": "Vision Screening",
        "vaccine": "Vaccination",
        "medication": "Medication",
        "custom": "Custom"
      }
    },
    "planner": {
      "title": "Family Health Planner",
      "subtitle": "Coordinate preventive care for your family",
      "addMember": "Add Family Member",
      "memberName": "Member Name",
      "relationship": "Relationship",
      "dateOfBirth": "Date of Birth",
      "viewCalendar": "View Calendar",
      "upcomingCare": "Upcoming Preventive Care",
      "nothingScheduled": "Nothing scheduled yet",
      "scheduleCheckup": "Schedule Checkup",
      "relationships": {
        "child": "Child",
        "spouse": "Spouse",
        "parent": "Parent",
        "sibling": "Sibling",
        "other": "Other"
      }
    },
    "content": {
      "infantCare": {
        "title": "Infant Preventive Care",
        "intro": "Essential preventive health practices for your baby's first year",
        "topics": [
          "Well-baby checkup schedule",
          "Developmental milestones to watch",
          "Safe sleep practices",
          "Nutrition and feeding",
          "Immunization schedule"
        ]
      },
      "childDevelopment": {
        "title": "Child Development & Milestones",
        "intro": "Understanding healthy growth and development",
        "topics": [
          "Physical development milestones",
          "Social and emotional growth",
          "Language development",
          "Cognitive milestones",
          "When to talk to your doctor"
        ]
      },
      "nutrition": {
        "title": "Nutrition & Healthy Growth",
        "intro": "Building healthy eating habits from the start",
        "topics": [
          "Age-appropriate nutrition",
          "Healthy snack ideas",
          "Managing picky eaters",
          "Food safety basics",
          "Hydration guidelines"
        ]
      },
      "safety": {
        "title": "Safety & Injury Prevention",
        "intro": "Creating a safe environment for your family",
        "topics": [
          "Home safety checklist",
          "Car seat safety",
          "Water safety",
          "Poison prevention",
          "Emergency preparedness"
        ]
      }
    }
  }
};
